// Errors internal-cas answers with 429 while a phone or email is limited.
export const OTP_RESEND_INTERVAL = 'OTP_RESEND_INTERVAL';
export const RECOVERY_BLOCKED = 'PASSWORD_RECOVERY_BLOCKED';

// Same wording as the cas login page; used until the portal has the
// cas.recovery.* keys.
const DEFAULT_TEXT: Record<string, string> = {
  [OTP_RESEND_INTERVAL]: 'ახალი კოდის მოთხოვნა შესაძლებელია {seconds} წამში',
  [RECOVERY_BLOCKED]: 'კოდის მოთხოვნის ლიმიტი ამოიწურა. სცადეთ {minutes} წუთში',
};

type Translate = (key: string) => string;

const fromPortal = (translate: Translate, key: string, fallback: string) => {
  const text = translate(key);
  return text && text !== key ? text : fallback;
};

export const isOtpLimitError = (message?: string): message is string =>
  !!message && message in DEFAULT_TEXT;

export const otpLimitText = (
  translate: Translate,
  error: string,
  remainingSec = 0
): string =>
  fromPortal(translate, `cas.recovery.${error}`, DEFAULT_TEXT[error])
    .replace('{seconds}', String(remainingSec))
    .replace('{minutes}', String(Math.ceil(remainingSec / 60)));

// Wrong-code answers of internal-cas, worded like the cas login page.
export const otpCheckText = (
  translate: Translate,
  data: { message?: string; attemptsLeft?: number }
): string | undefined => {
  if (data.message === 'OTP_ATTEMPTS_EXCEEDED') {
    return fromPortal(
      translate,
      'cas.registration.OTP_ATTEMPTS_EXCEEDED',
      'მცდელობების ლიმიტი ამოიწურა. მოითხოვეთ ახალი კოდი'
    );
  }
  if (data.message === 'INVALID_OTP') {
    return typeof data.attemptsLeft === 'number'
      ? fromPortal(
          translate,
          'cas.registration.OTP_ATTEMPTS_LEFT',
          'კოდი არ არის სწორი. დარჩენილი მცდელობა: {attempts}'
        ).replace('{attempts}', String(data.attemptsLeft))
      : translate('cas.registration.INVALID_OTP');
  }
  return data.message;
};
